import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
  Spinner,
  Form,
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import encode from "nodejs-base64-encode";
import axios from "axios";
import Baja from "../../Baja";
import BajaMultiple from "../../BajaMultiple";
import StatusMultiple from "../../StatusMultiple";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import moment from "moment";

import { v4 as uuidv4 } from "uuid";
import AutorizadoMultiple from "../../AutorizadoMultiple";
import { puede } from "../../../../permisos/permisos";

function SeguimientoPedidos() {
  const { user } = useContext(AuthContext);
  const URL_COLECCIONES = process.env.REACT_APP_URL_COLECCIONES;
  const URL_TELAS = process.env.REACT_APP_URL_TELAS;
  const URL_PEDIDOS = process.env.REACT_APP_URL_PEDIDOS;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_PROVEEDORES = process.env.REACT_APP_URL_PROVEEDORES;
  const URL_CORTES = process.env.REACT_APP_URL_CORTES;
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;

  let hoy = new Date();
  let inicio = new Date();
  inicio.setDate(inicio.getDate() - 60);

  let valida = new Date();
  valida.setDate(valida.getDate() + 8);

  let endDate = moment(hoy).format("YYYY-MM-DD");
  let startDate = moment(inicio).format("YYYY-MM-DD");

  const [pedidos, setPedidos] = useState([]);

  const [articulos, setArticulos] = useState([]);

  const [clientes, setClientes] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState("");
  const [selectedStatusTela, setSelectedStatusTela] = useState("");

  const [colaboradores, setColaboradores] = useState([]);
  const [selectedColaborador, setSelectedColaborador] = useState("");

  const [colecciones, setColecciones] = useState([]);
  const [selectedColeccion, setSelectedColeccion] = useState("");
  const [selectedStatusHabilitacion, setSelectedStatusHabilitacion] = useState("");
  const [selectedCortado, setSelectedCortado] = useState("");
  const [selectedStatusMaquila, setSelectedStatusMaquila] = useState("");


  const [telas, setTelas] = useState([]);
  const [selectedTela, setSelectedTela] = useState("");
  const [maquileros, setMaquileros] = useState([]);
  const [selectedMaquilero, setSelectedMaquilero] = useState("");
  const [selectedArticulo, setSelectedArticulo] = useState("");

  const [selectedFechaInicio, setSelectedFechaInicio] = useState(startDate);
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);
  const [selectedPatronistaFiltro, setSelectedPatronistaFiltro] = useState("");
  const [selectedMuestristaFiltro, setSelectedMuestristaFiltro] = useState("");
  const [selectedPloterFiltro, setSelectedPloterFiltro] = useState("");

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);
  const [validaBoton, setValidaBoton] = useState(true);
  const [totalTotalCantidad, setTotalTotalCantidad] = useState(0);

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");


  const [activo, setActivo] = useState("");
  const [selectedActivo, setSelectedActivo] = useState("Si");

  const [totalTotalPedidos, setTotalTotalPedidos] = useState(0);
  const [totalTotalCortes, setTotalTotalCortes] = useState(0);
  const [totalTotalEntradas, setTotalTotalEntradas] = useState(0);

  const [idCorteEdit, setIdCorteEdit] = useState("");
  const [porcentajeAvanceEdit, setPorcentajeAvanceEdit] = useState(0);
  const [auditorProduccionEdit, setAuditorProduccionEdit] = useState("");
  const [aceptadoCalidadEdit, setAceptadoCalidadEdit] = useState("");
  const [inspectorPTEdit, setInspectorPTEdit] = useState("");
  const [comentariosCalidadEdit, setComentariosCalidadEdit] = useState("");
  const [auditorCalidadEdit, setAuditorCalidadEdit] = useState("");
  const [modalEdit, setModalEdit] = useState(false);
  const toggleEdit = () => setModalEdit(!modalEdit);
  const [text, setText] = useState(false);


  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  useMemo(() => {
    axios
    .get(`${URL_PEDIDOS}SeguimientoFechas/${selectedFechaInicio}/${selectedFechaFin}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allPedidos = response.data;
        // Array para pagination
        let arrayTabla = allPedidos
          .sort((a, b) => (a.idPedido > b.idPedido ? 1 : -1))
          .map((a) => {
              return {
                temporada: a.TEMPORADA,
                idColeccion: a.IDTEMPORADA,
                modelo: a.MODELO,
                cliente: a.Cliente,
                idCliente: a.IdCliente,
                OP: a.OP,
                cantPedido: a.CantPedido,
                cantCorte: a.CantCorte,
                tela: a.TELA,
                composicion: a.TELA_COMPO,
                idTela: a.IDTELA,
                descripcion: a.DESCRIPCION,
                statusHabilitacion: a.STATUS_HABILITACION,
                statusTela: a.STATUS_TELA,
                fechaCorte: a.FECHA_CORTE,
                statusMaquilas: a.STATUS_MAQUILAS,
                maquilero: a.MAQUILERO_ASIGNADO,
                idMaquilero: a.ID_MAQUILERO_ASIGNADO,
                fechaSalidaMaquila: a.FECHA_ENVIO_MAQUILA,
                fechaCompromiso: a.FECHA_COMPROMISO_MAQUILA,
                fechaEntregaMaq: a.FECHA_ENTREGA_MAQ,
                fechaSurtido: a.FECHA_ENTREGA_CLIENTE,
                fecha: a.FECHA_PEDIDO,
                fechaCancelacion: a.FECHA_CANCELACION_PEDIDO,
                fechaEntrada: a.fechaEntradaAlmacen,
                cantidadEntrada: a.cantEntradaAlmacen,
                idCorte: a.ID_CORTE,
                porcentajeAvance: a.PORCENTAJE_AVANCE,
                auditorProduccion: a.AUDITOR_PRODUCCION,
                aceptadoCalidad: a.ACEPTADO_CALIDAD,
                inspectorPT: a.INSPECTOR_PT,
                comentariosCalidad: a.COMENTARIOS_CALIDAD,
                auditorCalidad: a.AUDITOR_CALIDAD,
               };

          })
          .filter(function (el) {
            return el != null;
          });

        let data = Object.values(arrayTabla);

        let dataFinal = Object.values(data);
        setComments(dataFinal);
        //
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_CLIENTES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allClientes = response.data;
        setClientes(allClientes);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_COLECCIONES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allColecciones = response.data;
        setColecciones(allColecciones);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_TELAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allTelas = response.data;
        setTelas(allTelas);
      })
      .catch((err) => {
        console.log(err);
      });

      axios
      .get(`${URL_PROVEEDORES}Maquileros`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allMaquileros = response.data;
        setMaquileros(allMaquileros);
      })
      .catch((err) => {
        console.log(err);
      });
    // axios
    //   .get(URL_ARTICULOS, {
    //     headers: {
    //       Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    //     },
    //   })
    //   .then((response) => {
    //     let allArticulos = response.data;
    //     setArticulos(allArticulos);
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
  }, [selectedFechaInicio, selectedFechaFin]);

function excel() {
  const formatFechaExcel = (fecha) => {
  if (!fecha) return "";

  // Si viene como YYYY-MM-DD, la regresamos tal cual formateada
  if (typeof fecha === "string") {
    const match = fecha.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (match) {
      const [, anio, mes, dia] = match;
      return `${dia}-${mes}-${anio.slice(-2)}`;
    }
  }

  // Si ya viene como Date real
  const f = new Date(fecha);
  if (isNaN(f.getTime())) return fecha;

  const dia = String(f.getUTCDate()).padStart(2, "0");
  const mes = String(f.getUTCMonth() + 1).padStart(2, "0");
  const anio = String(f.getUTCFullYear()).slice(-2);

  return `${dia}-${mes}-${anio}`;
};

  let computedComments = comments;
  if (search) {
    computedComments = computedComments.filter(
      (comment) =>
        comment.temporada.toLowerCase().includes(search.toLowerCase()) ||
        comment.modelo.toLowerCase().includes(search.toLowerCase()) ||
        comment.cliente.toLowerCase().includes(search.toLowerCase()) ||
        comment.OP.toLowerCase().includes(search.toLowerCase()) ||
        comment.tela.toLowerCase().includes(search.toLowerCase()) ||
        comment.composicion.toLowerCase().includes(search.toLowerCase()) ||
        comment.descripcion.toLowerCase().includes(search.toLowerCase()) ||
        comment.statusHabilitacion.toLowerCase().includes(search.toLowerCase()) ||
        comment.statusTela.toLowerCase().includes(search.toLowerCase()) ||
        comment.statusMaquilas.toLowerCase().includes(search.toLowerCase()) ||
        comment.maquilero.toLowerCase().includes(search.toLowerCase()) ||
        comment.auditorProduccion.toLowerCase().includes(search.toLowerCase()) ||
        comment.aceptadoCalidad.toLowerCase().includes(search.toLowerCase()) ||
        comment.inspectorPT.toLowerCase().includes(search.toLowerCase()) ||
        comment.auditorCalidad.toLowerCase().includes(search.toLowerCase()) ||
        comment.comentariosCalidad.toLowerCase().includes(search.toLowerCase()) ||
        comment.cantPedido.toString().includes(search) ||
        comment.cantCorte.toString().includes(search) ||
        comment.porcentajeProduccion.toString().includes(search) ||
        comment.cantidadEntrada.toString().includes(search)
    );
  }

  if (selectedCliente) {
    computedComments = computedComments.filter((e) =>
      e.idCliente.includes(selectedCliente)
    );
  }
  if (selectedMaquilero) {
    computedComments = computedComments.filter((e) =>
      e.idMaquilero.includes(selectedMaquilero)
    );
  }
  if (selectedColeccion) {
    computedComments = computedComments.filter((e) =>
      e.idColeccion.includes(selectedColeccion)
    );
  }
  if (selectedTela) {
    computedComments = computedComments.filter((e) =>
      e.idTela.includes(selectedTela)
    );
  }

  if (selectedStatusHabilitacion === "Entregado") {
    computedComments = computedComments.filter(
      (e) => e.statusHabilitacion === "Entregado"
    );
  }

  if (selectedStatusHabilitacion === "NO_ENTREGADO") {
    computedComments = computedComments.filter(
      (e) => e.statusHabilitacion !== "Entregado"
    );
  }

  if (selectedStatusTela === "Pendiente") {
    computedComments = computedComments.filter(
      (e) => e.statusTela === "Pendiente"
    );
  }

  if (selectedStatusTela === "Completo") {
    computedComments = computedComments.filter(
      (e) => e.statusTela == "Completo"
    );
  }

  if (selectedStatusTela === "Incompleto") {
    computedComments = computedComments.filter(
      (e) => e.statusTela == "Incompleto"
    );
  }

  if (selectedCortado === "Cortado") {
    computedComments = computedComments.filter((e) => e.cantCorte > 0);
  }

  if (selectedCortado === "NoCortado") {
    computedComments = computedComments.filter((e) => e.cantCorte == 0);
  }

  if (selectedStatusMaquila === "Entregado") {
    computedComments = computedComments.filter(
      (e) => e.statusMaquilas === "Entregado"
    );
  }

  if (selectedStatusMaquila === "NO_ENTREGADO") {
    computedComments = computedComments.filter(
      (e) => e.statusMaquilas !== "Entregado"
    );
  }

  if (selectedFechaInicio) {
    computedComments = computedComments.filter(
      (e) => e.fecha >= selectedFechaInicio
    );
  }

  if (selectedFechaFin) {
    computedComments = computedComments.filter(
      (e) => e.fecha <= selectedFechaFin
    );
  }

  setTotalItems(computedComments.length);

  if (
    sorting.field &&
    sorting.field != "cantPedido" &&
    sorting.field != "cantCorte" &&
    sorting.field != "cantidadEntrada"
  ) {
    const reversed = sorting.order === "asc" ? 1 : -1;
    computedComments = computedComments.sort(
      (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
    );
  }

  if (
    sorting.field &&
    sorting.order === "asc" &&
    (sorting.field == "cantPedido" ||
      sorting.field == "cantCorte" ||
      sorting.field == "cantidadEntrada")
  ) {
    computedComments = computedComments.sort((a, b) =>
      parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
    );
  }

  if (
    sorting.field &&
    sorting.order === "desc" &&
    (sorting.field == "cantPedido" ||
      sorting.field == "cantCorte" ||
      sorting.field == "cantidadEntrada")
  ) {
    computedComments = computedComments.sort((a, b) =>
      parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
    );
  }

  const dataExcel = computedComments.map((a) => {
    return {
      fechaPedido: formatFechaExcel(a.fecha),
      fechaCancelacion: formatFechaExcel(a.fechaCancelacion),
      temporada: a.temporada,
      modelo: a.modelo,
      cliente: a.cliente,
      OP: a.OP,
      cantPedido: a.cantPedido,
      tela: a.tela,
      composicion: a.composicion,
      statusHabilitacion: a.statusHabilitacion,
      statusTela: a.statusTela,
      fechaCorte: formatFechaExcel(a.fechaCorte),
      cantCorte: a.cantCorte,
      statusMaquilas: a.statusMaquilas,
      maquilero: a.maquilero,
      fechaSalida: formatFechaExcel(a.fechaSalidaMaquila),
      fechaCompromiso: formatFechaExcel(a.fechaCompromiso),
      fechaEntregaMaq: formatFechaExcel(a.fechaEntregaMaq),
      fechaEntradaAlma: formatFechaExcel(a.fechaEntrada),
      cantEntrada: a.cantidadEntrada,
      fechaSurtido: formatFechaExcel(a.fechaSurtido),
      porcentajeAvance: a.porcentajeAvance,
      auditorProduccion: a.auditorProduccion,
      inspectorPT: a.inspectorPT,
      aceptadoCalidad: a.aceptadoCalidad,
      comentariosCalidad: a.comentariosCalidad,
      auditorCalidad: a.auditorCalidad,
    };
  });

  const dataExportExcel = Object.values(dataExcel);
  const dataExcelLimpia = dataExportExcel.filter(function (el) {
    return el != null;
  });

  var option = {};

  option.fileName = "SeguimientoPedidos";

  option.datas = [
    {
      sheetData: dataExcelLimpia,
      sheetName: "SeguimientoPedidos",
      sheetFilter: [
        "fechaPedido",
        "fechaCancelacion",
        "temporada",
        "modelo",
        "cliente",
        "OP",
        "cantPedido",
        "tela",
        "composicion",
        "statusHabilitacion",
        "statusTela",
        "fechaCorte",
        "cantCorte",
        "statusMaquilas",
        "maquilero",
        "fechaSalida",
        "fechaCompromiso",
        "fechaEntregaMaq",
        "fechaEntradaAlma",
        "cantEntrada",
        "fechaSurtido",
        "porcentajeAvance",
        "auditorProduccion",
        "inspectorPT",
        "aceptadoCalidad",
        "comentariosCalidad",
        "auditorCalidad",
      ],
      sheetHeader: [
        "fechaPedido",
        "fechaCancelacion",
        "temporada",
        "modelo",
        "cliente",
        "OP",
        "cantPedido",
        "tela",
        "composicion",
        "statusHabilitacion",
        "statusTela",
        "fechaCorte",
        "cantCorte",
        "statusMaquilas",
        "maquilero",
        "fechaSalida",
        "fechaCompromiso",
        "fechaEntregaMaq",
        "fechaEntradaAlma",
        "cantEntrada",
        "fechaSurtido",
        "porcentajeAvance",
        "auditorProduccion",
        "inspectorPT",
        "aceptadoCalidad",
        "comentariosCalidad",
        "auditorCalidad",
      ],
    },
  ];

  var toExcel = new ExportJsonExcel(option);
  toExcel.saveExcel();
}

  const headers = [
    { name: "fecha pedido", field: "fecha", sortable: true },
    { name: "fecha cancelacion", field: "fechaCancelacion", sortable: true },
    { name: "temporada", field: "temporada", sortable: true },
    { name: "modelo", field: "modelo", sortable: true },
    { name: "cliente", field: "cliente", sortable: true },
    { name: "OP", field: "OP", sortable: true },
    { name: "cant Pedido", field: "cantPedido", sortable: true },
    { name: "tela", field: "tela", sortable: true },
    { name: "composicion", field: "composicion", sortable: true },
    { name: "status Habilitacion", field: "statusHabilitacion", sortable: true },
    { name: "status Tela", field: "statusTela", sortable: true },
    { name: "fecha Corte", field: "fechaCorte", sortable: true },
    { name: "cant Corte", field: "cantCorte", sortable: true },
    { name: "status Maquilas", field: "statusMaquilas", sortable: true },
    { name: "Maquilero", field: "maquilero", sortable: true },
    { name: "fecha salida", field: "fechaSalidaMaquila", sortable: true },
    { name: "fecha compromiso", field: "fechaCompromiso", sortable: true },
    { name: "fecha Entrega maq", field: "fechaEntregaMaq", sortable: true },
    { name: "fecha Entrada Alma", field: "fechaEntrada", sortable: true },
    { name: "Cant Entrada", field: "cantidadEntrada", sortable: true },
    { name: "fecha Surtido", field: "fechaSurtido", sortable: true },
    { name: "Porcentaje Avance", field: "porcentajeAvance", sortable: true },
    { name: "Auditor Produccion", field: "auditorProduccion", sortable: true },
    { name: "Inspector PT", field: "inspectorPT", sortable: true },
    { name: "Aceptado Calidad", field: "aceptadoCalidad", sortable: true },
    { name: "Comentarios Calidad", field: "comentariosCalidad", sortable: true },
    { name: "Auditor Calidad", field: "auditorCalidad", sortable: true },
    { name: "Editar", field: "editar", sortable: false },
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.temporada.toLowerCase().includes(search.toLowerCase()) ||
          comment.modelo.toLowerCase().includes(search.toLowerCase()) ||
          comment.cliente.toLowerCase().includes(search.toLowerCase()) ||
          comment.OP.toLowerCase().includes(search.toLowerCase()) ||
          comment.tela.toLowerCase().includes(search.toLowerCase()) ||
          comment.composicion.toLowerCase().includes(search.toLowerCase()) ||
          comment.descripcion.toLowerCase().includes(search.toLowerCase()) ||
          comment.statusHabilitacion.toLowerCase().includes(search.toLowerCase()) ||
          comment.statusTela.toLowerCase().includes(search.toLowerCase()) ||
          comment.statusMaquilas.toLowerCase().includes(search.toLowerCase()) ||
          comment.maquilero.toLowerCase().includes(search.toLowerCase()) ||
          comment.auditorProduccion.toLowerCase().includes(search.toLowerCase()) ||
          comment.inspectorPT.toLowerCase().includes(search.toLowerCase()) ||
          comment.aceptadoCalidad.toLowerCase().includes(search.toLowerCase()) ||
          comment.auditorCalidad.toLowerCase().includes(search.toLowerCase()) ||
          comment.comentariosCalidad.toLowerCase().includes(search.toLowerCase()) ||

          comment.cantPedido.toString().includes(search) ||
          comment.cantCorte.toString().includes(search) ||
          comment.porcentajeAvance.toString().includes(search) ||
          comment.cantidadEntrada.toString().includes(search)
      );
    }
    if (selectedCliente) {
      computedComments = computedComments.filter((e) =>
        e.idCliente.includes(selectedCliente)
      );
    }
       if (selectedMaquilero) {
      computedComments = computedComments.filter((e) =>
        e.idMaquilero.includes(selectedMaquilero)
      );
    }
    if (selectedColeccion) {
      computedComments = computedComments.filter((e) =>
        e.idColeccion.includes(selectedColeccion)
      );
    }
    if (selectedTela) {
      computedComments = computedComments.filter((e) =>
        e.idTela.includes(selectedTela)
      );
    }

if (selectedStatusHabilitacion === "Entregado") {
  computedComments = computedComments.filter(
    (e) => e.statusHabilitacion === "Entregado"
  );
}

if (selectedStatusHabilitacion === "NO_ENTREGADO") {
  computedComments = computedComments.filter(
    (e) => e.statusHabilitacion !== "Entregado"
  );
}
if (selectedStatusTela === "Pendiente") {
  computedComments = computedComments.filter(
    (e) => e.statusTela === "Pendiente"
  );
}

if (selectedStatusTela === "Completo") {
  computedComments = computedComments.filter(
    (e) => e.statusTela == "Completo"
  );
}
if (selectedStatusTela === "Incompleto") {
  computedComments = computedComments.filter(
    (e) => e.statusTela == "Incompleto"
  );
}
if (selectedCortado === "Cortado") {
  computedComments = computedComments.filter(
    (e) => e.cantCorte > 0
  );
}

if (selectedCortado === "NoCortado") {
  computedComments = computedComments.filter(
    (e) => e.cantCorte == 0
  );
}

if (selectedStatusMaquila === "Entregado") {
  computedComments = computedComments.filter(
    (e) => e.statusMaquilas === "Entregado"
  );
}

if (selectedStatusMaquila === "NO_ENTREGADO") {
  computedComments = computedComments.filter(
    (e) => e.statusMaquilas !== "Entregado"
  );
}


    if (selectedFechaInicio) {
      computedComments = computedComments.filter(
        (e) => e.fecha >= selectedFechaInicio
      );
    }

    if (selectedFechaFin) {
      computedComments = computedComments.filter(
        (e) => e.fecha <= selectedFechaFin
      );
    }

   
    let ped = computedComments.map((c) => parseFloat(c.cantPedido));
    let TPed = ped.reduce((t, cantidad, index) => t + cantidad, 0);
    setTotalTotalPedidos(TPed);

    let cort = computedComments.map((c) => parseFloat(c.cantCorte));
    let TCort = cort.reduce((t, cantidad, index) => t + cantidad, 0);
    setTotalTotalCortes(TCort);

    let ent = computedComments.map((c) => parseFloat(c.cantidadEntrada));
    let TEnt = ent.reduce((t, cantidad, index) => t + cantidad, 0);
    setTotalTotalEntradas(TEnt);

    setTotalItems(computedComments.length);

    //Sorting comments
    if (
      sorting.field &&
      sorting.field != "cantPedido" &&
      sorting.field != "cantCorte" &&
      sorting.field != "cantidadEntrada" &&
      sorting.field != "porcentajeAvance"
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      (sorting.field == "cantPedido" ||
        sorting.field == "cantCorte" ||
        sorting.field == "cantidadEntrada" ||
        sorting.field == "porcentajeAvance")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      (sorting.field == "cantPedido" ||
        sorting.field == "cantCorte" ||
        sorting.field == "cantidadEntrada" ||
        sorting.field == "porcentajeAvance")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    selectedCliente,
    selectedMaquilero,
    selectedColeccion,
    selectedStatusHabilitacion,
    selectedStatusTela,
    selectedCortado,
    selectedStatusMaquila,
    selectedTela,
    selectedArticulo,
    // activo,
    selectedFechaInicio,
    selectedFechaFin,
  ]);

  function EditDatos(
    idCorte,
    porcentajeAvance,
    auditorProduccion,
    inspectorPT,
    aceptadoCalidad,
    comentariosCalidad,
    auditorCalidad,
  ) {
    setIdCorteEdit(idCorte);
    setPorcentajeAvanceEdit(porcentajeAvance);
    setAuditorProduccionEdit(auditorProduccion);
    setInspectorPTEdit(inspectorPT);
    setAceptadoCalidadEdit(aceptadoCalidad);
    setComentariosCalidadEdit(comentariosCalidad);
    setAuditorCalidadEdit(auditorCalidad);
    toggleEdit();
  }


const EditDatosSave = async (event) => {
  event.preventDefault();

  const result = await Swal.fire({
    title: "Estas seguro?",
    text: "Se actualizara el corte",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Si, Enviar!",
  });

  if (!result.isConfirmed) return;

  try {
    await axios.patch(
      `${URL_CORTES}/${idCorteEdit}`,
      {
        porcentajeAvance: porcentajeAvanceEdit?.trim() || 0,
        auditorProduccion: auditorProduccionEdit?.trim() || "NA",
        inspectorPT: inspectorPTEdit?.trim() || "NA",
        aceptadoCalidad: aceptadoCalidadEdit?.trim() || "Pendiente",
        comentariosCalidad: comentariosCalidadEdit?.trim() || "NA",
        auditorCalidad: auditorCalidadEdit?.trim() || "NA",
      },
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      }
    );

    await axios.post(
      URL_LOGS,
      {
        tipo: "Editar Corte",
        detalle: `Editar datos de Corte ${idCorteEdit}`,
        user: user.id,
      },
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      }
    );

    // 🔥 ACTUALIZA SOLO EL ELEMENTO EDITADO EN comments
    setComments(prev =>
      prev.map(item => {
        if (String(item.idCorte) !== String(idCorteEdit)) return item;

        return {
          ...item,
          porcentajeAvance: porcentajeAvanceEdit,
          auditorProduccion: auditorProduccionEdit,
          inspectorPT: inspectorPTEdit,
          aceptadoCalidad: aceptadoCalidadEdit,
          comentariosCalidad: comentariosCalidadEdit,
          auditorCalidad: auditorCalidadEdit,
        };
      })
    );

    Swal.fire("Actualizado!", "Corte actualizado con éxito", "success");

  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: error?.response?.data || "Algo salió mal",
    });
  }
};

return (
    <>
      <Header />
      <br />
      <br />
      {puede(user, "ventas.pedidos.ver") ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
              <Button
                size="sm"
                href="/MenuVentas"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
            </Col>
          </Row>

          <h3 align="center">Seguimiento Pedidos</h3>
          <div className="row">
            <div className="col-md-8">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
            <div className="col-md-4 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          <Row>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Inicio</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaInicio}
                required
                onChange={(e) => {
                  setSelectedFechaInicio(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Fin</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaFin}
                required
                onChange={(e) => {
                  setSelectedFechaFin(e.target.value);
                }}
              />
            </Col>
          </Row>
          <br />
          <Table size="sm" striped borderless className="table-responsive-xl table-dark-header">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tr>
              <td></td>
              <td></td>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedColeccion}
                  onChange={(e) => {
                    setSelectedColeccion(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="0">Selecciona</option>
                  {colecciones
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.name}</option>;
                    })}
                </Input>
              </td>
              <td></td>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedCliente}
                  onChange={(e) => {
                    setSelectedCliente(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="0">Selecciona</option>
                  {clientes
                    .sort((a, b) =>
                      a.nombre_comercial > b.nombre_comercial ? 1 : -1,
                    )
                    .map((a) => {
                      return (
                        <option value={a._id}>{a.nombre_comercial}</option>
                      );
                    })}
                </Input>
              </td>
              <td></td>
              <td></td>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedTela}
                  onChange={(e) => {
                    setSelectedTela(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="0">Selecciona</option>
                  {telas
                    .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.nombre}</option>;
                    })}
                </Input>
              </td>
              <td></td>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedStatusHabilitacion}
                  onChange={(e) => {
                    setSelectedStatusHabilitacion(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  <option value="Entregado">Entregado</option>
                  <option value="NO_ENTREGADO">No Entregado</option>
                </Input>
              </td>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedStatusTela}
                  onChange={(e) => {
                    setSelectedStatusTela(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  <option value="Pendiente">Pendiente</option>
                  <option value="Incompleto">Incompleto</option>
                  <option value="Completo">Completo</option>
                </Input>
              </td>
              <td></td>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedCortado}
                  onChange={(e) => {
                    setSelectedCortado(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  <option value="Cortado">Cortado</option>
                  <option value="NoCortado">No Cortado</option>
                </Input>
              </td>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedStatusMaquila}
                  onChange={(e) => {
                    setSelectedStatusMaquila(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  <option value="Entregado">Entregado</option>
                  <option value="NO_ENTREGADO">No Entregado</option>
                </Input>
              </td>
              <td>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedMaquilero}
                  onChange={(e) => {
                    setSelectedMaquilero(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  {maquileros
                    .sort((a, b) =>
                      a.nombre_comercial > b.nombre_comercial ? 1 : -1,
                    )
                    .map((a) => {
                      return (
                        <option value={a._id}>{a.nombre_comercial}</option>
                      );
                    })}
                </Input>
              </td>
            </tr>
            <tbody>
              {commentsData.map((a) => {
                return (
                  <tr>
                    <td>{a.fecha}</td>
                    <td>{a.fechaCancelacion}</td>
                    <td>{a.temporada}</td>
                    <td>{a.modelo}</td>
                    <td>{a.cliente}</td>
                    <td>{a.OP}</td>
                    <td>{a.cantPedido}</td>
                    <td>{a.tela}</td>
                    <td>{a.composicion}</td>
                    <td>{a.statusHabilitacion}</td>
                    <td>{a.statusTela}</td>
                    <td>{a.fechaCorte}</td>
                    <td>{a.cantCorte}</td>
                    <td>{a.statusMaquilas}</td>
                    <td>{a.maquilero}</td>
                    <td>{a.fechaSalidaMaquila}</td>
                    <td>{a.fechaCompromiso}</td>
                    <td>{a.fechaEntregaMaq}</td>
                    <td>{a.fechaEntrada}</td>
                    <td>{a.cantidadEntrada}</td>
                    <td>{a.fechaSurtido}</td>
                    <td>{a.porcentajeAvance}%</td>
                    <td>{a.auditorProduccion}</td>
                    <td>{a.inspectorPT}</td>
                    <td>{a.aceptadoCalidad}</td>
                    <td>{a.comentariosCalidad}</td>
                    <td>{a.auditorCalidad}</td>
                    <td>
                     <Button
  size="sm"
  className="btn"
  color="info"
  disabled={!user.editAuditor}
  onClick={(e) =>
    EditDatos(
      a.idCorte,
      a.porcentajeAvance,
      a.auditorProduccion,
      a.inspectorPT,
      a.aceptadoCalidad,
      a.comentariosCalidad,
      a.auditorCalidad
    )
  }
>
  <i className="far fa-edit"></i>
</Button>
                    </td>
                  </tr>
                );
              })}
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td className="negrita" align="right">
                  TOTALES
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US").format(totalTotalPedidos)}
                </td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US").format(totalTotalCortes)}
                </td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US").format(totalTotalEntradas)}
                </td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </Table>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      ) : undefined}
      <br />

      <Modal size="sm" isOpen={modalEdit} toggle={toggleEdit}>
            <ModalHeader toggle={toggleEdit}>
              <h4>Editar Datos</h4>
            </ModalHeader>
            <ModalBody>
              <Form onSubmit={EditDatosSave}
              >
                <Row>
                  <Col md={6}>
                    <Label>Porcentaje Avance</Label>
                    <Input
                      type="number"
                      value={porcentajeAvanceEdit}
                      onChange={(e) => {
                        setPorcentajeAvanceEdit(e.target.value);
                      }}
                    />
                  </Col>
                  <Col md={6}>
                    <Label>Auditor Produccion</Label>
                    <Input
                      type="text"
                      placeholder="AuditorProduccion"
                      value={auditorProduccionEdit}
                      onChange={(e) => {
                        setAuditorProduccionEdit(e.target.value);
                      }}
                    />
                  </Col>
                </Row>

                <Row>
                   <Col md={6}>
                    <Label>Comentarios Calidad</Label>
                    <Input
                      type="text"
                      placeholder="ComentariosCalidad"
                      value={comentariosCalidadEdit}
                      onChange={(e) => {
                        setComentariosCalidadEdit(e.target.value);
                      }}
                    />
                  </Col>
                   <Col md={6}>
                    <Label>Auditor Calidad</Label>
                    <Input
                      type="text"
                      placeholder="AuditorCalidad"
                      value={auditorCalidadEdit}
                      onChange={(e) => {
                        setAuditorCalidadEdit(e.target.value);
                      }}
                    />
                  </Col>
                </Row>

                <Row>
                   <Col md={6}>
                    <Label>Inspector PT</Label>
                    <Input
                      type="text"
                      placeholder="Inspector PT"
                      value={inspectorPTEdit}
                      onChange={(e) => {
                        setInspectorPTEdit(e.target.value);
                      }}
                    />
                  </Col>
                   <Col md={6}>
                    <Label>Aceptado Calidad</Label>
                    <Input
                      type="select"
                      placeholder="Aceptado Calidad"
                      value={aceptadoCalidadEdit}
                      onChange={(e) => {
                        setAceptadoCalidadEdit(e.target.value);
                      }}
                    >
                      <option value="Pendiente">Pendiente</option>
                      <option value="Aceptado">Aceptado</option>
                      <option value="Rechazado">Rechazado</option>
                    </Input>
                  </Col>
                </Row>

                <br />
                <Row>
                    <Button type="submit" className="btn btn-success">
                      Guardar
                    </Button>

                  <div>
                    <SweetAlert
                      show={text}
                      title="Creado con Exito"
                      onConfirm={() => {
                        setText(false);
                      }}
                    />
                  </div>
                </Row>
              </Form>
            </ModalBody>
          </Modal>

      {loader}
    </>
  );
}

export default SeguimientoPedidos;
